<template>
  <div class="weather-station">
    <v-container>
      <div class="header-container">
        <h2>Estaciones Meteorológicas</h2>
      </div>
      <v-row class="mt-8 d-flex justify-center">
        <v-col cols="10" sm="5" md="5" lg="5" xl="5" class="my-auto">
          <v-img
            :src="validateImage(path + investigador.image, failed_image)"
            v-on:error="onImgError"
            data-aos="fade-up"
            :height="imageShouldExpand('mdAndUp') ? '100%' : 'auto'"
            :width="imageShouldExpand('mdAndUp') ? 'auto' : '90vw'"
            contain
          >
            <!-- <div class="image-inner-text body">
              <b>{{ investigador.name }}</b>
            </div> -->
          </v-img>
        </v-col>
        <v-col md="7" lg="7" xl="7" cols="12" data-aos="fade-up" data-aos-delay="50">
          <h5>ICAARO y EMASQUI</h5>
          <div class="mt-3 body" v-html="investigador.description"></div>
          <div class="mt-3 body" data-aos="fade-up" data-aos-delay="100" v-html="data.history"></div>
        </v-col>
        <!-- <v-col>
          <div class="mt-3" data-aos="fade-up" data-aos-delay="100" v-html="data.history"></div>
        </v-col> -->
      </v-row>
      <h5 class="mt-10" data-aos-delay="150" data-aos="fade-up">Estaciones</h5>
    </v-container>
    <v-container  style="position:relative">
      <GoogleMap data-aos="fade-up" data-aos-delay="200" :locations="locations" />
    </v-container>
    <v-container>
      <h5 class="mt-8 mb-5" data-aos="fade-up">Información en tiempo real</h5>
      <div class="mt-3" data-aos="fade-up" data-aos-delay="50" v-html="estaciones.description"></div>
      <v-row justify="center">
        <v-col
          class="d-flex justify-center col-sm-6 col-md-4 col-lg-4 col-xl-4 col-12"
          v-for="(station, index) in weatherStations"
          data-aos="fade-up"
          :data-aos-delay="index * 50 + 50"
        >
          <iframe
            :src="station"
            width="338"
            height="495"
            scrolling="no"
            class="mt-4"
            frameborder="0"
          ></iframe>
        </v-col>
      </v-row>
      <h5 data-aos="fade-up" data-aos-delay="50" class="mt-10">Monitoreo de Calidad del Aire</h5>
      <div class="mt-3" data-aos="fade-up" data-aos-delay="100" v-html="calidadDelAire.description"></div>
      <v-row data-aos="fade-up" data-aos-delay="150">
        <v-col class="d-flex" cols="12" v-for="station in calidadDelAire.urls">
          <!-- justify-center col-sm-6 col-md-4 col-lg-4 col-xl-4 col-12 -->
          <iframe
            :src="station"
            width="100%"
            height="500"
            scrolling="no"
            class="mt-4"
            frameborder="0"
          ></iframe>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import $ from "jquery";
import GoogleMap from "../components/Maps/GoogleMap.vue";

export default {
  name: "WeatherStations",
  components: {
    GoogleMap
  },
  data: () => ({
    failed_image: false,
    weatherStations: [],
    locations: []
  }),
  computed: {
    data() {
      return this.$info.estaciones;
    },
    investigador() {
      return this.$info.estaciones.investigador;
    },
    estaciones() {
      return this.$info.estaciones.estacionesMeteorologicas;
    },
    calidadDelAire() {
      return this.$info.estaciones.calidadDelAire;
    },
    path() {
      return $(location).attr("origin") + "/archivos/estaciones/";
    }
  },
  methods: {
    validateImage(image, failed_image) {
      return !failed_image ? image : "https://www.uabc.mx/wp-content/uploads/2022/01/RFoto01.jpg";
    },
    onImgError: function(event) {
      this.failed_image = true;
    },
    imageShouldExpand(height) {
      return this.$vuetify.breakpoint[height];
    },
  },
  beforeMount() {
    this.locations = this.estaciones.locations.map((station, index) => {
      this.weatherStations.push(station.url);
      return [station.name, station.location.lat, station.location.lng, 7];
    });
  }
};
</script>
<style lang="scss" scoped>
.weather-station {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 100px;
}
.image-inner-text {
  position: absolute;
  bottom: 0px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  padding-left: 10px;
  color: white;
  padding: 6px 10px;
}

@media (max-width: 960px) {
  .weather-station  {
    padding-top: 75px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
